import {
  LAYOUT_COMPONENT_TYPE,
  REGISTRY_BLOCK,
  type LayoutBlock,
} from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const announcementBarBandDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.announcementBar,
  componentType: LAYOUT_COMPONENT_TYPE.announcementBar,
  registryBlockKey: REGISTRY_BLOCK.presentation.announcementBarBand,
  pageId: null,
  content: {
    message: loc3(
      'Am 24.–26. Dezember geschlossen — ab 27. wieder für Sie da.',
      'Closed 24–26 December — open again from the 27th.',
      'Đóng cửa 24–26 tháng 12 — mở lại từ ngày 27.',
    ),
    ctaLabel: loc3('Reservieren', 'Reserve', 'Đặt bàn'),
    ctaIntent: loc3('section', 'section', 'section'),
    ctaHref: loc3('/#reserve', '/#reserve', '/#reserve'),
    sectionIcon: loc3('MessageSquare', 'MessageSquare', 'MessageSquare'),
    tone: loc3('notice', 'notice', 'notice'),
    // startsAt / endsAt omitted — empty schedule means always eligible (Visibility + message decide).
  },
  media: {},
  displayOrder: -2,
  /** Product default — owners opt in via Zone 4 Visibility. */
  hidden: true,
};
